export type QRValidationFunction = (qrData: string) => string | false;

// Verdi device QR code format (LoRaWAN device QR code specification), e.g.
//   LW:D0:FFFFFFFFFFFFFFFF:0004A30B00EA9E70:FFFF2102
//   ^  ^  ^                ^                ^   ^
//   |  |  |                |                |   `-- vendor_profile_id
//   |  |  `-- join_eui     `-- eui          `-- vendor_id
//   |  `-- schema_id
//   `-- prefix (hard-coded to `LW`)
//   Note: The suffix is optional and can be up to 10 characters long.
//   JoinEUI (formerly AppEUI) identifies the join server programmed at shipment. TR005 allows any
//   16 hex characters. Verdi labels print FFFFFFFFFFFFFFFF. A RAK gateway label prints a vendor
//   JoinEUI instead; see rakWirelessRakGatewayQRCodeValidation.
export const VERDI_DEVICE_QR_FORMAT =
    /^(?<prefix>LW):(?<schema_id>[0-9a-fA-F]{2}):(?<join_eui>[0-9a-fA-F]{16}):(?<eui>[0-9a-fA-F]{16}):(?<vendor_id>[0-9a-fA-F]{4})(?<vendor_profile_id>[0-9a-fA-F]{4})(?<suffix>.{0,10})$/;

/** Used for decommissioned device types that can no longer be registered. */
export const decommissionedDeviceRegistration: QRValidationFunction = () => false;

export const saplingQRCodeValidation: QRValidationFunction = (QR: string) => {
    const match = QR.match(/LW:D0:[0-9a-fA-F]{16}:(0004A30B00[a-f0-9A-F]{6}):(0000|FFFF)(00|10|11)[a-f0-9A-F]{2}/);
    if (!match || !match[1]) {
        return false;
    }
    return "eui-" + match[1].toLowerCase();
};

export const sproutMicroQRCodeValidation: QRValidationFunction = (QR: string) => {
    const match = QR.match(/LW:D0:[0-9a-fA-F]{16}:(0004A30B00[a-f0-9A-F]{6}):(0000|FFFF)(00|20)[a-f0-9A-F]{2}/);
    if (!match || !match[1]) {
        // Support reprogrammed sapling devices
        return saplingQRCodeValidation(QR);
    }
    return "eui-" + match[1].toLowerCase();
};

export const sproutBlockQRCodeValidation: QRValidationFunction = (QR: string) => {
    const match = QR.match(/LW:D0:[0-9a-fA-F]{16}:(0004A30B00[a-f0-9A-F]{6}):(0000|FFFF)(00|21)[a-f0-9A-F]{2}/);
    if (!match || !match[1]) {
        return false;
    }
    return "eui-" + match[1].toLowerCase();
};

export const gen4BlockQRCodeValidation: QRValidationFunction = (QR: string) => {
    const match = QR.match(/LW:D0:[0-9a-fA-F]{16}:([a-f0-9A-F]{16}):(FFFF)(31)[a-f0-9A-F]{2}/);
    if (!match || !match[1]) {
        return false;
    }
    return "eui-" + match[1].toLowerCase();
};
